<template>
  <div class="not-found-page">
    <div class="not-found-container">
      <!-- Декоративный фон с сеткой -->
      <div class="grid-background"></div>
      
      <!-- Основной контент -->
      <div class="content">
        <!-- Большая цифра 404 -->
        <div class="error-code">
          <span class="digit">4</span>
          <span class="digit gear">
            <svg viewBox="0 0 100 100" class="gear-icon">
              <path d="M97.6,55.7V44.3l-13.6-2.9c-0.8-3.4-2.1-6.5-3.8-9.4l8.2-11.2l-8.1-8.1L69,21c-2.9-1.7-6.1-3-9.4-3.8L56.7,3.6H44.3l-2.9,13.6c-3.4,0.8-6.5,2.1-9.4,3.8L20.8,12.8l-8.1,8.1l8.2,11.2c-1.7,2.9-3,6.1-3.8,9.4L3.6,44.3v11.4l13.6,2.9c0.8,3.4,2.1,6.5,3.8,9.4l-8.2,11.2l8.1,8.1L32,79c2.9,1.7,6.1,3,9.4,3.8l2.9,13.6h11.4l2.9-13.6c3.4-0.8,6.5-2.1,9.4-3.8l11.2,8.2l8.1-8.1L79,68c1.7-2.9,3-6.1,3.8-9.4L97.6,55.7z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z" fill="currentColor"/>
            </svg>
          </span>
          <span class="digit">4</span>
        </div>

        <!-- Сообщение -->
        <h1 class="title">Страница не найдена</h1>
        <p class="description">
          Запрашиваемый ресурс отсутствует в системе или был перемещён.
          <br>
          Проверьте правильность адреса или вернитесь на главную.
        </p>

        <!-- Путь -->
        <div class="path-info">
          <span class="path-label">Запрошенный путь:</span>
          <code class="path-value">{{ currentPath }}</code>
        </div>

        <!-- Кнопки действий -->
        <div class="actions">
          <button @click="goBack" class="btn btn-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" class="btn-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clip-rule="evenodd" />
            </svg>
            Назад
          </button>
          <router-link to="/" class="btn btn-primary">
            <svg xmlns="http://www.w3.org/2000/svg" class="btn-icon" viewBox="0 0 20 20" fill="currentColor">
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
            </svg>
            На главную
          </router-link>
        </div>
      </div>

      <!-- Декоративные элементы -->
      <div class="decorative-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  
  computed: {
    currentPath() {
      return this.$route.fullPath;
    }
  },
  
  methods: {
    goBack() {
      if (window.history.length > 2) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    }
  }
}
</script>

<style scoped>
.not-found-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%);
  font-family: 'Figtree', system-ui, sans-serif;
  overflow: hidden;
  position: relative;
}

.not-found-container {
  position: relative;
  text-align: center;
  padding: 2rem;
  max-width: 600px;
  width: 100%;
}

/* Фоновая сетка */
.grid-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(rgba(59, 130, 246, 0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(59, 130, 246, 0.08) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
}

.content {
  position: relative;
  z-index: 10;
}

/* Код ошибки 404 */
.error-code {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
}

.digit {
  font-size: 8rem;
  font-weight: 800;
  background: linear-gradient(180deg, #3b82f6 0%, #2563eb 50%, #1d4ed8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 0 60px rgba(59, 130, 246, 0.2);
  line-height: 1;
}

.digit.gear {
  display: flex;
  align-items: center;
  justify-content: center;
}

.gear-icon {
  width: 7rem;
  height: 7rem;
  color: #f59e0b;
  animation: rotate 8s linear infinite;
  filter: drop-shadow(0 0 15px rgba(245, 158, 11, 0.3));
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Заголовок и описание */
.title {
  font-size: 1.875rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 1rem;
  letter-spacing: -0.025em;
}

.description {
  color: #64748b;
  font-size: 1rem;
  line-height: 1.75;
  margin-bottom: 2rem;
}

/* Информация о пути */
.path-info {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(203, 213, 225, 0.8);
  border-radius: 0.75rem;
  padding: 1rem 1.5rem;
  margin-bottom: 2rem;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.path-label {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
  margin-bottom: 0.5rem;
}

.path-value {
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
  font-size: 0.875rem;
  color: #ea580c;
  word-break: break-all;
}

/* Кнопки */
.actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-size: 0.9375rem;
  font-weight: 600;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  border: none;
}

.btn-icon {
  width: 1.25rem;
  height: 1.25rem;
}

.btn-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.35);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.45);
  transform: translateY(-2px);
}

.btn-secondary {
  background: white;
  color: #475569;
  border: 1px solid #cbd5e1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.btn-secondary:hover {
  background: #f8fafc;
  border-color: #94a3b8;
  transform: translateY(-2px);
}

/* Декоративные формы */
.decorative-shapes {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

.shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.25;
  filter: blur(80px);
}

.shape-1 {
  width: 400px;
  height: 400px;
  background: #93c5fd;
  top: -100px;
  right: -100px;
  animation: float 20s ease-in-out infinite;
}

.shape-2 {
  width: 300px;
  height: 300px;
  background: #fcd34d;
  bottom: -50px;
  left: -50px;
  animation: float 15s ease-in-out infinite reverse;
}

.shape-3 {
  width: 200px;
  height: 200px;
  background: #c4b5fd;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: pulse 10s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(20px, -30px);
  }
  50% {
    transform: translate(-10px, 20px);
  }
  75% {
    transform: translate(30px, 10px);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.2;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.35;
    transform: translate(-50%, -50%) scale(1.2);
  }
}

/* Адаптив */
@media (max-width: 640px) {
  .digit {
    font-size: 5rem;
  }
  
  .gear-icon {
    width: 4.5rem;
    height: 4.5rem;
  }
  
  .title {
    font-size: 1.5rem;
  }
  
  .description {
    font-size: 0.9375rem;
  }
  
  .actions {
    flex-direction: column;
  }
  
  .btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
